import React from 'react'

const Gast = () => {
  return (
    <>

<div className="dr-header">
        <div className="header-contant">
          <h1> Services</h1>
          <p>Doctor {" > "} Gastric Disorders </p>
        </div>
      </div>

     <div className="diabp">
        <h1>Gastric Disorders</h1>
        <div className="bp-row">
          <div className="bp-col">
            <p>
            Gastrointestinal diseases affect the gastrointestinal (GI) tract from the mouth to the anus. There are two types: functional and structural. Some examples include nausea/vomiting, food poisoning, lactose intolerance and diarrhea.
            </p>
            <p>
            The inflammation of gastritis is most often the result of infection with the same bacterium that causes most stomach ulcers or the regular use of certain pain relievers. Drinking too much alcohol also can contribute to gastritis.
            </p>
            <p>
            Gastritis or gas problem in the stomach is a condition where the stomach membrane layer gets disturbed and leads to the secretion of acids. Once these acids come in contact with the stomach walls, it gives rise to pain and discomfort. This condition ultimately leads to a problem called gastric.
            </p>
           
          </div>
          <div className="bp-col">
            <img src="./img/gas.jpg" alt="" />
          </div>
        </div>
      </div>
    </>
  )
}

export default Gast